import { FC, useContext, useState } from 'react';

import { Button, ExclamationIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';

import s from './AdvertisementInfo.module.scss';

export const AdvertisementInfo: FC = () => {
  const { t } = useContext(LocalizationContext);
  const [infoBlock, setInfoBlock] = useState(true);

  if (!infoBlock) return null;

  return (
    <div className={cn(s.container)}>
      <div className={s.icon}>
        <ExclamationIcon />
      </div>
      <div className={s.content}>
        <div className={s.description}>
          <span className={s.title}>{t('advertisement.info.title')}</span>
          <span>{t('advertisement.info.description')}</span>
        </div>
        <Button
          onClick={() => setInfoBlock(false)}
          variant="outline"
          className={s.reload}
          size="s"
        >
          {t('ok')}
        </Button>
      </div>
    </div>
  );
};
